import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
export default function CallToAction() {
  return <section data-section-id="232593" id="diferencial-e-cta-final" className="relative py-24 md:py-32 px-4 md:px-8 bg-background overflow-hidden flex items-center justify-center">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-3xl aspect-square bg-primary/5 rounded-full blur-3xl pointer-events-none" />

      <Card className="relative w-full max-w-4xl mx-auto bg-white/40 backdrop-blur-sm border border-border/50 shadow-sm rounded-3xl overflow-hidden">
        <CardContent className="p-10 md:p-16 flex flex-col items-center text-center gap-6">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-foreground tracking-tighter">
            Design estratégico e direto.
          </h2>
          
          <p className="font-default text-xl md:text-2xl text-muted-foreground max-w-2xl leading-relaxed">
            Transformamos sua visão em autoridade visual com precisão e exclusividade.
          </p>
          
          <div className="pt-6">
            <Button asChild size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-primary/20 px-10 h-16 text-lg font-medium">
              <Link to="https://wa.me/5511969100007?text=Olá,%20vim%20pelo%20site%20da%20ITC+%20e%20quero%20entender%20como%20vocês%20podem%20me%20ajudar">
                <MessageCircle className="mr-2 size-6" />
                Fale no WhatsApp
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </section>;
}